<div id="icon" class="header-icon" #initialsContainer>{{ initials }}</div>
